import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { Button } from './ui/button';
import { useTheme } from '../context/ThemeContext';

// Theme switch. Defaults to the sidebar's full-width ghost-button style, but
// `variant`/`className` can be overridden for use elsewhere (e.g. an icon-only
// button on auth pages that have no sidebar).
const ThemeToggle = ({ variant = 'ghost', className = '', iconOnly = false }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <Button
      variant={variant}
      className={className}
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      data-testid="theme-toggle"
    >
      {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
      {!iconOnly && <span className="ml-2">{isDark ? 'Light mode' : 'Dark mode'}</span>}
    </Button>
  );
};

export default ThemeToggle;
